import React from 'react';

// Public landing page (served at "/"). Placeholder for the future
// signup / paid-moderation flow. The actual platform lives under /admin.
const Landing: React.FC = () => {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      color: '#e8e8f0',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      background: 'radial-gradient(1200px 600px at 50% -10%, #232544 0%, #0f1117 55%)',
    }}>
      {/* Header */}
      <header style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '20px 32px', maxWidth: 1080, margin: '0 auto', width: '100%',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontWeight: 700, fontSize: 20 }}>
          <span style={{
            width: 28, height: 28, borderRadius: 8,
            background: 'linear-gradient(135deg, #6366f1, #a855f7)', display: 'inline-block',
          }} />
          crowdtask
        </div>
        <a href="/admin/login" style={{
          color: '#c7c9e0', textDecoration: 'none', fontSize: 14,
          border: '1px solid #333650', padding: '7px 16px', borderRadius: 8,
        }}>Admin sign in</a>
      </header>

      {/* Hero */}
      <main style={{
        flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', textAlign: 'center', padding: '40px 24px',
        maxWidth: 760, margin: '0 auto',
      }}>
        <div style={{
          fontSize: 13, letterSpacing: 1.5, textTransform: 'uppercase',
          color: '#8b8fb8', marginBottom: 20,
        }}>Coming soon</div>
        <h1 style={{
          fontSize: 'clamp(36px, 6vw, 60px)', lineHeight: 1.1, margin: 0,
          fontWeight: 800, letterSpacing: -1,
        }}>
          Get paid to<br />
          <span style={{
            background: 'linear-gradient(135deg, #818cf8, #c084fc)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
          }}>moderate content</span>
        </h1>
        <p style={{
          fontSize: 18, color: '#aeb1cf', maxWidth: 540, marginTop: 24, lineHeight: 1.6,
        }}>
          Earn rewards for reviewing and classifying images. Work on your own schedule,
          from anywhere. Sign-ups open soon — join the waitlist.
        </p>

        {/* Waitlist (placeholder, not wired up yet) */}
        <form
          onSubmit={(e) => { e.preventDefault(); alert('Thanks! Signups are not open yet — we’ll be in touch.'); }}
          style={{ display: 'flex', gap: 10, marginTop: 36, width: '100%', maxWidth: 440, flexWrap: 'wrap' }}
        >
          <input
            type="email"
            required
            placeholder="you@email.com"
            style={{
              flex: 1, minWidth: 200, padding: '13px 16px', borderRadius: 10,
              border: '1px solid #333650', background: '#171a2b', color: '#fff', fontSize: 15,
            }}
          />
          <button type="submit" style={{
            padding: '13px 24px', borderRadius: 10, border: 'none', cursor: 'pointer',
            background: 'linear-gradient(135deg, #6366f1, #a855f7)', color: '#fff',
            fontSize: 15, fontWeight: 600,
          }}>Join waitlist</button>
        </form>
      </main>

      <footer style={{
        textAlign: 'center', padding: 24, color: '#6a6d90', fontSize: 13,
      }}>
        © {new Date().getFullYear()} crowdtask
      </footer>
    </div>
  );
};

export default Landing;
